export default "__VITE_ASSET__DMnbApGA__"